import { render, staticRenderFns } from "./selectScreenModel.vue?vue&type=template&id=1742b320&scoped=true"
import script from "./selectScreenModel.vue?vue&type=script&lang=js"
export * from "./selectScreenModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742b320",
  null
  
)

export default component.exports